var map = {
	"./avaka_logo": "./app/javascript/images/avaka_logo.png",
	"./avaka_logo.png": "./app/javascript/images/avaka_logo.png",
	"./avaka_mini": "./app/javascript/images/avaka_mini.png",
	"./avaka_mini.png": "./app/javascript/images/avaka_mini.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";